module.exports = __webpack_public_path__ + "static/media/arrow-03-svgrepo-com.218ceea8.svg";